import { Tooltip, TooltipProps, tooltipClasses } from '@mui/material';
import { IToolTipProps } from './IToolTip';
import { styled } from '@mui/system';

const ToolTip = (props: IToolTipProps) => {
    if (props.withHtml) return <HtmlTooltip {...props} />;
    return (
        <Tooltip title={props.title} placement={props.placement}>
            {props.children}
        </Tooltip>
    );
};

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'transparent',
    },
}));

export default ToolTip;
